import { z } from "zod";
// Backend Configuration Schema (includes secrets)
export const BackendConfigSchema = z.object({
    // AWS Configuration
    AWS_REGION: z.string().default("us-east-1"),
    AWS_ACCOUNT_ID: z.string().optional(),
    // API Configuration
    API_ENDPOINT: z.string().url().optional(),
    // WorkOS Authentication (Backend only - includes API key)
    WORKOS_API_KEY: z.string(),
    VITE_WORKOS_CLIENT_ID: z.string(),
    // SendGrid Email
    SENDGRID_API_KEY: z.string().optional(),
    // Sentry Error Tracking
    SENTRY_DSN: z.string().optional(),
    SENTRY_ENVIRONMENT: z
        .enum(["development", "staging", "production"])
        .default("development"),
    // Logging
    LOG_LEVEL: z.enum(["debug", "info", "warn", "error"]).default("info"),
    // Database
    DATABASE_URL: z.string().optional(),
    // Model Configuration
    MODEL_DOWNLOAD_URL: z.string().url().optional(),
});
// Frontend/Electron Configuration Schema (NO secrets)
export const FrontendConfigSchema = z.object({
    // API Configuration
    API_ENDPOINT: z.string().url().optional(),
    // WorkOS Client ID only (NO API key)
    VITE_WORKOS_CLIENT_ID: z.string(),
    // Sentry Error Tracking
    SENTRY_DSN: z.string().optional(),
    SENTRY_ENVIRONMENT: z
        .enum(["development", "staging", "production"])
        .default("development"),
    // Logging
    LOG_LEVEL: z.enum(["debug", "info", "warn", "error"]).default("info"),
});
// Legacy export for backward compatibility
export const ConfigSchema = BackendConfigSchema;
export function validateBackendConfig(env) {
    try {
        return BackendConfigSchema.parse(env);
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            const errorDetails = error.issues
                .map((issue) => `${issue.path.join(".")}: ${issue.message}`)
                .join("\n");
            throw new Error(`Backend configuration validation failed:\n${errorDetails}`);
        }
        throw error;
    }
}
export function validateFrontendConfig(env) {
    try {
        return FrontendConfigSchema.parse(env);
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            const errorDetails = error.issues
                .map((issue) => `${issue.path.join(".")}: ${issue.message}`)
                .join("\n");
            throw new Error(`Frontend configuration validation failed:\n${errorDetails}`);
        }
        throw error;
    }
}
// Legacy function for backward compatibility
export function validateConfig(env) {
    return validateBackendConfig(env);
}
